import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { SaveApplicationNotesParams, saveApplicationNotes } from 'commons/service/client/application'

export const useSaveApplicationNotes: WriteHook<SaveApplicationNotesParams, unknown> = (opts) =>
  useMutationManager<SaveApplicationNotesParams, unknown>(saveApplicationNotes, opts)
